var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { makeStyles } from '@material-ui/core';
import AppBar from '../AppBar';
import Container from '../Container';
import Divider from '../Divider';
import LinearProgress from '../LinearProgress';
var useStyles = makeStyles(function (theme) { return ({
    progressBarColorPrimary: {
        backgroundColor: theme.palette.secondary.main,
    },
    progressColorPrimary: {
        height: 5,
        backgroundColor: theme.palette.grey[300],
    },
}); });
var FixedFooter = function (props) {
    var classes = useStyles();
    var children = props.children, appBarProps = props.appBarProps, _a = props.dividerTop, dividerTop = _a === void 0 ? false : _a, _b = props.dividerBottom, dividerBottom = _b === void 0 ? false : _b, _c = props.progressBar, progressBar = _c === void 0 ? false : _c, _d = props.progressBarValue, progressBarValue = _d === void 0 ? 0 : _d;
    return (React.createElement(React.Fragment, null,
        progressBar && (React.createElement(LinearProgress, { "data-test-locator": "Fixed Footer ProgressBar - " + progressBarValue, variant: "determinate", classes: {
                colorPrimary: classes.progressColorPrimary,
                barColorPrimary: classes.progressBarColorPrimary,
            }, value: progressBarValue })),
        React.createElement(AppBar, __assign({ position: "static", color: "inherit" }, appBarProps),
            dividerTop && React.createElement(Divider, { "data-test-locator": "Fixed Footer Divider Top" }),
            React.createElement(Container, null, children),
            dividerBottom && (React.createElement(Divider, { "data-test-locator": "Fixed Footer Divider Bottom" })))));
};
export default FixedFooter;
//# sourceMappingURL=index.js.map